var ajaxCount = 0;
var axiomUtils = {
    //    onlineStatus: undefined,
    deleteProperties: function (object, arrProperties) {
        if (typeof arrProperties === 'string') {
            arrProperties = [arrProperties];
        }
        var keys = Object.keys(object);
        var newObject = {};
        for (var i = 0; i < keys.length; i++) {
            if (arrProperties.indexOf(keys[i]) == -1) {
                newObject[keys[i]] = object[keys[i]];
            }
        }
        object = null;
        return newObject;
    },
    getIndexOf: function (array, number, addIfNotAvailable, key, probableIndex) {
        if (array.length == 0) {
            if (addIfNotAvailable) {
                array.push(number);
                return array.length - 1;
            }
            else {
                return -1;
            }
        }
        var top = 0;
        var bottom = array.length;
        var center = Math.floor((top + bottom) / 2);
        //if(number<array[0])
        if (((key == undefined) ? (number < array[0]) : (number[key] < array[0][key]))) {
            if (addIfNotAvailable) {
                array.splice(0, 0, number);
                return 0;
            }
            else {
                if (probableIndex)
                    return -1;
                else
                    return -1;
            }
        }
        //else if(number>array[bottom-1])
        else if (((key == undefined) ? (number > array[bottom - 1]) : (number[key] > array[bottom - 1][key]))) {
            if (addIfNotAvailable) {
                array.push(number);
                return array.length - 1;
            }
            else {
                if (probableIndex)
                    return bottom;
                else
                    return -1;
            }
        }
        else {
            while (true) {
                var val = array[center];
                //if(number == val)
                if (((key == undefined) ? (number == val) : (number[key] == val[key]))) {
                    return center;
                }
                else if (bottom - top <= 1) {
                    if (addIfNotAvailable) {
                        array.splice(bottom, 0, number);
                        return bottom;
                    }
                    else {
                        if (probableIndex)
                            return top;
                        else
                            return -1;
                    }
                }
                else {
                    //if(number<val)
                    if (((key == undefined) ? (number < val) : (number[key] < val[key]))) {
                        bottom = center;
                        center = Math.floor((top + bottom) / 2);
                    }
                    else {
                        top = center;
                        center = Math.floor((top + bottom) / 2);
                    }
                }
            }
        }
    },
    updateDependencyMatrix_old: function (dependency, newList) {
        var dependencyJSON = {};
        var localDependencyRefArray = [];
        var localNewListRefArray = [];
        var retryArray = [];
        var lastSkippedValue = undefined;
        var lastSkippedIndex = -1;
        for (var i = 0; i < dependency.length; i++) {
            localDependencyRefArray[i] = dependency[i].reference;
        }

        var removeList = [];
        for (var i = 0; i < newList.length; i++) {
            var refIndex = localDependencyRefArray.indexOf(newList[i].reference);
            if (refIndex == -1) {
                newList[i].calculationRank = 1;
                newList[i].calculated = false;
                localNewListRefArray[i] = newList[i].reference;
            }
            else {
                dependency[refIndex] = newList[i];
                removeList.push(newList[i].reference);
                newList.splice(i, 1);
                i--;
            }
        }
        while (removeList.length > 0) {
            var itemKey = removeList.shift();
            var itemIndex = localDependencyRefArray.indexOf(itemKey);
            if (itemIndex != -1) {
                var item = dependency[itemIndex];
                dependency.splice(itemIndex, 1);
                localDependencyRefArray.splice(itemIndex, 1);
                item.calculationRank = 1;
                item.calculated = false;
                newList.push(item);
                localNewListRefArray.push(itemKey);
                for (var i = 0; i < item.usedReferences.length; i++) {
                    removeList.push(item.usedReferences[i]);
                }
            }
        }
        for (var i = 0; i < newList.length; i++) {
            var obj = newList[i];
            var allCellsCalculated = true;
            var maxRank = 0;
            var maxRankIndex = 0;
            for (var j = 0; j < obj.usedReferences.length; j++) {
                if (obj.reference == obj.usedReferences[j]) {
                    allCellsCalculated = false;
                    break;
                }
                var refIndex = localDependencyRefArray.indexOf(obj.usedReferences[j]);
                if (refIndex != -1) {
                    if (dependency[refIndex].calculated != false) {
                        if (maxRank <= dependency[refIndex].calculationRank) {
                            maxRank = dependency[refIndex].calculationRank;
                            maxRankIndex = refIndex;
                        }
                    }
                    else {
                        allCellsCalculated = false;
                        break;
                    }
                }
                else {
                    var refIndex = localNewListRefArray.indexOf(obj.usedReferences[j]);
                    if (refIndex != -1) {
                        allCellsCalculated = false;
                        break;
                    }
                }
            }
            var retryIndex = retryArray.indexOf(obj.reference);
            if (allCellsCalculated) {
                maxRank++;
                obj.calculationRank = maxRank;
                obj.calculated = true;
                dependency.splice(maxRankIndex + 1, 0, obj);
                localDependencyRefArray.splice(maxRankIndex + 1, 0, obj.reference);
                retryArray.splice(refIndex, 1);
            }
            else {
                if (retryIndex == -1) {
                    retryArray.push(obj.reference);
                }
                else if (lastSkippedValue == obj.reference && lastSkippedIndex == i) {
                    break;
                }
                if (lastSkippedIndex != i) {
                    lastSkippedValue = obj.reference;
                    lastSkippedIndex = i;
                }
                newList.splice(i, 1);
                newList.push(obj);

                var item = localDependencyRefArray[i];
                localNewListRefArray.splice(i, 1);
                localNewListRefArray.push(item);

                i--;

            }
        }
        for (var i = 0; i < dependency.length; i++) {
            dependencyJSON[dependency[i].reference] = i;
        }
        return { arrDependency: dependency, jsonDependency: dependencyJSON, dependencyError: retryArray };
    },
    updateDependencyMatrix: function (dependency, newList) {
        var dependencyError = dependency.errors;
        dependency = dependency.values;
        var localDependencyRefArray = [];
        var dependencyIndex = [];
        for (var i = 0; i < dependency.length; i++) {
            var newIndex = this.getIndexOf(localDependencyRefArray, dependency[i].reference, true);
            dependencyIndex.splice(newIndex, 0, i);
        }
        //dependency = newDependency;
        //newDependency = [];

        //        var removeList = [];
        var minIndex = +Infinity;
        for (var i = 0; i < newList.length; i++) {
            var refIndex = this.getIndexOf(localDependencyRefArray, newList[i].reference, false);
            for (var j = 0; j < newList[i].usedReferences.length; j++) {
                var usedIndex = this.getIndexOf(localDependencyRefArray, newList[i].usedReferences[j], false);
                if (usedIndex != -1) {
                    if (minIndex > dependencyIndex[usedIndex])
                        minIndex = dependencyIndex[usedIndex];
                    //                    this.getIndexOf(removeList, dependency[dependencyIndex[usedIndex]].reference, true);
                    //                    if (usedIndex < i) {
                    //                        debugger;
                    //                        //i--;
                    //                    }
                }
            }
            if (refIndex != -1) {
                if (minIndex > dependencyIndex[refIndex])
                    minIndex = dependencyIndex[refIndex];
                dependency[dependencyIndex[refIndex]] = newList[i];
                //                this.getIndexOf(removeList, newList[i].reference, true);
                newList.splice(i, 1);
                i--;
            }
        }
        newList = newList.concat(dependency.splice(minIndex, dependency.length - minIndex));
        //        for (var i = minIndex; i < dependency.length; i++) {
        //            //newList.push(dependency.splice(i, 1)[0]);
        //            i--;
        //        }
        //        while (removeList.length > 0) {
        //            var itemKey = removeList.shift();
        //            var itemIndex = this.getIndexOf(localDependencyRefArray, itemKey, false);
        //            if (itemIndex != -1) {

        //                var item = dependency[dependencyIndex[itemIndex]];
        //                //dependency.splice(itemIndex, 1);
        //                //localDependencyRefArray.splice(itemIndex, 1);

        //                newList.push(item);
        //                dependency[dependencyIndex[itemIndex]].deleteFromHere = true;
        //                //                for (var i = 0; i < item.usedReferences.length; i++) {
        //                //                    this.getIndexOf(removeList, item.usedReferences[i], true);
        //                //                }
        //            }
        //        }

        //        for (var i = 0; i < dependency.length; i++) {
        //            if (dependency[i].deleteFromHere) {
        //                dependency.splice(i, 1);
        //                i--;
        //            }
        //        }

        for (var i = 0; i < newList.length; i++) {
            var errorIndex = this.getIndexOf(dependencyError, newList[i].reference, false);
            if (errorIndex != -1) {
                dependencyError.splice(errorIndex, 1);
            }
        }

        var result = this.sortBasedOnDependentChild(newList);
        for (var i = result.arrDependency.length - 1; i >= 0; i--) {
            dependency.unshift(result.arrDependency[i]);
        }
        for (var i = 0; i < result.dependencyError.length; i++) {
            this.getIndexOf(dependencyError, result.dependencyError[i], true);
        }



        result = null;
        ;
        var dependencyJSON = {};
        var retryArray = [];
        for (var i = 0; i < dependency.length; i++) {
            dependency[i] = axiomUtils.deleteProperties(dependency[i], ['pendingUsedReferences', 'deleteFromHere']);
            dependencyJSON[dependency[i].reference] = i;
        }
        return { arrDependency: dependency, jsonDependency: dependencyJSON, dependencyError: dependencyError };
    },
    sortBasedOnDependentChild: function (dependency) {
        var localDependencyRefArray = [];
        var newDependencyRefArray = [];
        var newDependency = [];
        for (var i = 0; i < dependency.length; i++) {
            dependency[i].pendingUsedReferences = ([]).concat(dependency[i].usedReferences);
            var newIndex = this.getIndexOf(localDependencyRefArray, dependency[i].reference, true);
            newDependency.splice(newIndex, 0, dependency[i]);
        }
        dependency = newDependency;
        newDependency = [];
        var retryArray = [];
        while (dependency.length > 0) {
            var depth = [dependency[0].reference];
            while (depth.length > 0) {
                var refIndex = this.getIndexOf(localDependencyRefArray, depth[0], false);
                /*var retryIndex = this.getIndexOf(retryArray, depth[0], false);
                if(retryIndex != -1 && dependency[refIndex].pendingUsedReferences.length>0) {
                var refIndex = this.getIndexOf(localDependencyRefArray, depth[0], false);
                depth.shift();
                newDependency.push(dependency.splice(refIndex, 1)[0]);
                newDependencyRefArray.push(localDependencyRefArray.splice(refIndex, 1)[0]);
                }
                else*/
                {
                    var obj = dependency[refIndex];
                    if (obj == undefined)
                        debugger;
                    var processed = true;
                    for (var j = 0; j < obj.pendingUsedReferences.length; j++) {
                        if (obj.reference == obj.pendingUsedReferences[j]) {
                            //circular reference
                            this.getIndexOf(retryArray, obj.reference, true);
                            depth.shift();
                            newDependency.push(dependency.splice(refIndex, 1)[0]);
                            newDependencyRefArray.push(localDependencyRefArray.splice(refIndex, 1)[0]);
                            processed = false;
                        }
                        else if (this.getIndexOf(retryArray, obj.pendingUsedReferences[j], false) != -1) {
                            // circular reference depedent
                            this.getIndexOf(retryArray, obj.reference, true);
                            depth.shift();
                            newDependency.push(dependency.splice(refIndex, 1)[0]);
                            newDependencyRefArray.push(localDependencyRefArray.splice(refIndex, 1)[0]);
                            processed = false;
                        }
                        else if (depth.indexOf(obj.pendingUsedReferences[j]) != -1) {
                            // circular reference depedent
                            this.getIndexOf(retryArray, obj.reference, true);
                            depth.shift();
                            newDependency.push(dependency.splice(refIndex, 1)[0]);
                            newDependencyRefArray.push(localDependencyRefArray.splice(refIndex, 1)[0]);
                            processed = false;
                        }
                        else {
                            var index = this.getIndexOf(localDependencyRefArray, obj.pendingUsedReferences[j], false);
                            if (index == -1) {
                                // do nothing
                            }
                            else {
                                //this.getIndexOf(retryArray, depth[0], true);
                                depth.unshift(localDependencyRefArray[index]);
                                //obj.pendingUsedReferences.splice(0, j + 1);
                                processed = false;
                                break;
                            }
                        }
                    }
                    if (processed) {
                        depth.shift();
                        newDependency.push(dependency.splice(refIndex, 1)[0]);
                        newDependencyRefArray.push(localDependencyRefArray.splice(refIndex, 1)[0]);
                    }
                }
            }
        }
        for (var i = 0; i < retryArray.length; i++) {
            var index = newDependencyRefArray.indexOf(retryArray[i]);
            newDependency.splice(index, 1);
            newDependencyRefArray.splice(index, 1);
        }
        var dependencyJSON = {};
        for (var i = 0; i < newDependency.length; i++) {
            newDependency[i] = axiomUtils.deleteProperties(newDependency[i], ['pendingUsedReferences']);
            dependencyJSON[newDependency[i].reference] = i;
        }
        return { arrDependency: newDependency, jsonDependency: dependencyJSON, dependencyError: retryArray };
    },
    sortBasedOnDependentParent: function (dependencyArray) {
        var localDependencyRefArray = [];
        var dependency = [];
        for (var i = 0; i < dependencyArray.length; i++) {
            for (var j = 0; j < dependencyArray[i].usedReferences.length; j++) {
                var refIndex = localDependencyRefArray.indexOf(dependencyArray[i].usedReferences[j]);
                if (refIndex == -1) {
                    dependency.push({ reference: dependencyArray[i].usedReferences[j], usedReferences: [dependencyArray[i].reference] });
                    localDependencyRefArray.push(dependencyArray[i].usedReferences[j]);
                }
                else {
                    dependency[refIndex].usedReferences.push(dependencyArray[i].reference);
                }
            }
        }
        return this.sortBasedOnDependentChild(dependency);
    },
    sortBasedOnDependentChild_old: function (dependency) {
        var dependencyJSON = {};
        var localDependencyRefArray = [];
        var retryArray = [];
        var lastSkippedValue = undefined;
        var lastSkippedIndex = -1;
        var retryDependency = {};
        for (var i = 0; i < dependency.length; i++) {
            dependency[i].calculationRank = 1;
            dependency[i].calculated = false;
            localDependencyRefArray[i] = dependency[i].reference;
        }
        for (var i = 0; i < dependency.length; i++) {
            var obj = dependency[i];
            var allCellsCalculated = true;
            var maxRank = 0;
            for (var j = 0; j < obj.usedReferences.length; j++) {
                if (obj.reference == obj.usedReferences[j]) {
                    allCellsCalculated = false;
                    break;
                }
                var refIndex = localDependencyRefArray.indexOf(obj.usedReferences[j]);
                if (refIndex != -1) {
                    if (dependency[refIndex].calculated != false) {
                        if (maxRank < dependency[refIndex].calculationRank) {
                            maxRank = dependency[refIndex].calculationRank;
                        }
                    }
                    else {
                        allCellsCalculated = false;
                        break;
                    }
                }
            }
            var retryIndex = retryArray.indexOf(obj.reference);
            if (allCellsCalculated) {
                maxRank++;
                obj.calculationRank = maxRank;
                obj.calculated = true;
                retryArray.splice(retryIndex, 1);
            }
            else {
                if (retryIndex == -1) {
                    retryArray.push(obj.reference);
                    for (var refCounter = 0; refCounter < obj.usedReferences.length; refCounter++) {
                        if (!retryDependency.hasOwnProperty(obj.usedReferences[refCounter])) {
                            retryDependency[obj.usedReferences[refCounter]] = [];
                        }
                        if (retryDependency[obj.usedReferences[refCounter]].indexOf(obj.reference) == -1)
                            retryDependency[obj.usedReferences[refCounter]].push(obj.reference);
                    }
                }
                else {
                    if (lastSkippedValue == obj.reference && lastSkippedIndex == i) {
                        //debugger;
                        break;
                    }
                }
                var insertAt = dependency.length;
                if (retryDependency.hasOwnProperty(obj.reference)) {
                    for (var depIndex = 0; depIndex < retryDependency[obj.reference].length; depIndex++) {
                        var indexInRetryArray = localDependencyRefArray.indexOf(retryDependency[obj.reference][depIndex]);
                        if (indexInRetryArray != -1) {
                            if (insertAt > indexInRetryArray && indexInRetryArray > i)
                                insertAt = indexInRetryArray;
                        }
                        else {
                            //debugger;
                        }
                    }
                }
                if (lastSkippedIndex != i) {
                    lastSkippedValue = obj.reference;
                    lastSkippedIndex = i;
                }
                dependency.splice(i, 1);
                dependency.splice(insertAt, 0, obj);

                var item = localDependencyRefArray[i];
                localDependencyRefArray.splice(i, 1);
                localDependencyRefArray.splice(insertAt, 0, item);

                i--;
            }
        }

        for (var i = 0; i < dependency.length; i++) {
            dependencyJSON[dependency[i].reference] = i;
        }
        return { arrDependency: dependency, jsonDependency: dependencyJSON, dependencyError: retryArray };
    },
    ifNull: function (val, defaultval) {
        if (val == null || val == 'null')
            return defaultval;
        else
            return val;
    },
    /**********************************************************
    <Summary>
    <Name>saveData</Name>
    <Description>Call this function to save table data outside table domain</Description>
    <ReturnType>Nothing</ReturnType>
    </Summary>
    ***********************************************************/
    saveDataGlobal: function (json, cbError, cbSuccess) {
        //save data
        var string = getUrlStringtable();
        var xhr = new XMLHttpRequest();
        xhr.addEventListener("error", transferFailed, false);
        xhr.addEventListener("abort", transferCanceled, false);
        xhr.onreadystatechange = function () {
            if (xhr.readyState == 4) {
                var response = JSON.parse(xhr.responseText);
                var newID = response.content.newID;
                var updatedColumnsInfo = response.content.updatedColumnsInfo;

                if (response.content.modifiedDateEPOC)
                    lastModifiedOnEPOC = response.content.modifiedDateEPOC;
                if (response.content.message == -2) {
                    if (cbError)
                        cbError("Error has occured.");
                }
                else if (response.code == -1) {
                    if (cbError)
                        cbError("Duplicate viewname found.");
                }
                else {
                    if (response.status == true) {
                        var objAxiom = $_1_7('#' + json.axiomGridID);
                        if (objAxiom.length > 0) {
                            if (newID != undefined && newID.length > 0) {
                                axiomGridMethods.updateGridPkIDRowID(objAxiom, newID);
                            }
                            //reset layout formview details
                            axiomGridMethods.resetLayoutFields(objAxiom);
                            axiomGridMethods.updateTableStructure(objAxiom, updatedColumnsInfo);
                            axiomGridMethods.setAddedRowsList(objAxiom, []);
                            axiomGridMethods.setModifiedCellsList(objAxiom, []);
                            axiomGridMethods.setDeletedRowsList(objAxiom, []);
                            axiomGridMethods.setUniqueKeysList(objAxiom, []);
                            axiomGridMethods.setLastSavedBy(objAxiom, response.content.modifiedBy);
                            axiomGridMethods.setLastModifiedDate(objAxiom, response.content.modifiedOn);
                            axiomGridMethods.setCurrentVersion(objAxiom, response.content.versionName);
                            axiomGridMethods.setDeletedColumnsInfo(objAxiom);
                        }

                        if (cbSuccess)
                            cbSuccess(response);
                    }
                    else {
                        if (cbError)
                            cbError(response);
                    }

                }
            }
        };

        xhr.open("post", string, true);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        xhr.setRequestHeader("X-Request-By", "HTTPAxiomMethod");
        xhr.setRequestHeader("Content-Type", "text/json");
        xhr.send(JSON.stringify({ action: 'saveTableStructureAndData', sessionID: '', tableID: json.tableID, userID: json.userID,
            deletedRows: json.arrDeletedRowsList, addedRows: json.arrAddedRowsList, changedData: json.arrModifiedCellsList, uniqueKeys: json.arrUniqueKeysList, chunkNumber: 0,
            viewID: json.viewId, parentViewID: json.viewId,
            filterID: json.filterID,
            tableName: replaceSpecialChar(json.tName), tableDescription: replaceSpecialChar(json.tDescription), tagStr: json.tagStr,
            isMasterView: 1, projectID: json.projectID,
            isImported: 0, connectorID: 'null',
            fieldDetails: json.fNames,
            columnsInfo: json.tableColumns,
            versionDisabled: json.versionDisabled,
            lastModifiedOn: json.lastModifiedOn,
            isStructChanged: json.isStructChanged,
            URL: table_getBaseUrlString(),
            isLastChunk: true,
            freezeRC: json.freezeJSON
        }));

        /*var jqxhr = $_1_7.post(
        string,
        { action: 'saveTableStructureAndData', sessionID: '', tableID: json.tableID,
        deletedRows: json.arrDeletedRowsList, addedRows: json.arrAddedRowsList, changedData: json.arrModifiedCellsList, uniqueKeys: json.arrUniqueKeysList, chunkNumber: 0,
        viewID: json.viewId, parentViewID: json.viewId,
        filterID: json.filterID,
        tableName: replaceSpecialChar(json.tName), tableDescription: replaceSpecialChar(json.tDescription), tagStr: json.tagStr,
        isMasterView: 1, projectID: json.projectID,
        isImported: 0, connectorID: 'null',
        fieldDetails: json.fNames,
        columnsInfo: json.tableColumns,
        versionDisabled: json.versionDisabled,
        lastModifiedOn: json.lastModifiedOn,
        isStructChanged: json.isStructChanged,
        URL: table_getBaseUrlString(),
        isLastChunk: true
        },
        function (data) {
        var response = JSON.parse(xhr.responseText);
        var newID = response.content.newID;
        var updatedColumnsInfo = response.content.updatedColumnsInfo;

        if (response.content.modifiedDateEPOC)
        lastModifiedOnEPOC = response.content.modifiedDateEPOC;
        if (response.content.message == -2) {
        if (cbError)
        cbError("Error has occured.");
        }
        else if (response.code == -1) {
        if (cbError)
        cbError("Duplicate viewname found.");
        }
        else {
        if (response.status == true) {
        var objAxiom = $_1_7('#' + json.axiomGridID);
        if (objAxiom.length > 0) {
        if (newID != undefined && newID.length > 0) {
        axiomGridMethods.updateGridPkIDRowID(objAxiom, newID);
        }
        //reset layout formview details
        axiomGridMethods.resetLayoutFields(objAxiom);
        axiomGridMethods.updateTableStructure(objAxiom, updatedColumnsInfo);
        axiomGridMethods.setAddedRowsList(objAxiom, []);
        axiomGridMethods.setModifiedCellsList(objAxiom, []);
        axiomGridMethods.setDeletedRowsList(objAxiom, []);
        axiomGridMethods.setUniqueKeysList(objAxiom, []);
        axiomGridMethods.setLastSavedBy(objAxiom, response.content.modifiedBy);
        axiomGridMethods.setLastModifiedDate(objAxiom, response.content.modifiedOn);
        axiomGridMethods.setCurrentVersion(objAxiom, response.content.versionName);
        axiomGridMethods.setDeletedColumnsInfo(objAxiom);
        }
        }
        else {
        if (cbError)
        cbError(response.content.message);
        }
        if (cbSuccess)
        cbSuccess(response.content);
        }
        },
        'json');*/
    },
    getColumnNameFromIndex: function (number, s) {
        if (s === undefined)
            s = "";
        var self = this;
        var rem = number % 26;
        s = String.fromCharCode(65 + rem) + s;
        number = number / 26 - 1;
        return number < 0 ? s : self.getColumnNameFromIndex(number, s);
    },
    getColumnIndexFromName: function (name) {
        var self = this;
        var index = 0;
        for (var i = 0; i < name.length; i++) {
            index += (name.charCodeAt(i) - 64) * Math.pow(26, (name.length - i) - 1);
        }
        return index;
    },
    //    getOnlineStatus: function (cb) {
    //        if (axiomUtils.onlineStatus != undefined) {
    //            cb(axiomUtils.onlineStatus);
    //        }
    //        else {
    //            setTimeout(function () {
    //                axiomUtils.getOnlineStatus(cb);
    //            });
    //        }
    //    },
    //    arrOnlineStatusCB: [],
    //    bindStatusUpdate: function (cb) {
    //        axiomUtils.arrOnlineStatusCB.push(cb);
    //        if (activeConnectionStack_socket_connected != undefined) {
    //            //First parameter is status & 2nd parameter is index of CB. THis is required to unbindStatusUpdate
    //            cb(activeConnectionStack_socket_connected, axiomUtils.arrOnlineStatusCB.length - 1);
    //        }
    //    },
    //    unbindStatusUpdate: function (cbIndex) {
    //        axiomUtils.arrOnlineStatusCB.splice(cbIndex, 0);
    //    },
    //    updateOnlineStatus: function () {
    //        for (var cbIndex = 0; cbIndex < axiomUtils.arrOnlineStatusCB.length; cbIndex++) {
    //            if (axiomUtils.arrOnlineStatusCB[cbIndex])
    //                axiomUtils.arrOnlineStatusCB[cbIndex](status);
    //        }
    //    },
    //    onlineCheckStarted: false,
    //    checkOnline: function () {
    //        return;
    //        this.onlineCheckStarted = true;
    //        var resReceived = false;
    //        var xmlhttp;
    //        if (window.XMLHttpRequest) {// code for IE7+, Firefox, Chrome, Opera, Safari
    //            xmlhttp = new XMLHttpRequest();
    //        }
    //        else {// code for IE6, IE5
    //            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    //        }
    //        xmlhttp.onreadystatechange = function () {
    //            if (xmlhttp.readyState == 4) {
    //                resReceived = true;
    //                if (xmlhttp.status == 200) {
    //                    axiomUtils.updateOnlineStatus(true);
    //                    setTimeout(function () {
    //                        axiomUtils.checkOnline();
    //                    }, 5000);
    //                }
    //                else {
    //                    axiomUtils.updateOnlineStatus(false);
    //                    setTimeout(function () {
    //                        axiomUtils.checkOnline();
    //                    }, 5000);
    //                }
    //            }
    //        }
    //        xmlhttp.open("GET", "/images/slider.png", true);
    //        xmlhttp.send();
    //        setTimeout(function () {
    //            if (resReceived == false) {
    //                axiomUtils.updateOnlineStatus(false);
    //                setTimeout(function () {
    //                    axiomUtils.checkOnline();
    //                }, 1);
    //            }
    //        }, 5000);
    //    },
    getVariableValue: function (key) {
        var object = window;
        var parts = key.split(".");
        if (object.hasOwnProperty(parts[0]) === false) {
            object = window['UserSpecific'];
        }
        for (var i = 0; i < parts.length && object != undefined; i++) {
            object = object[parts[i]];
        }
        return object;
    },
    getCurrentUserDetail: function (cb) {
        var url = document.URL;
        url = url.substr(0, url.indexOf('/', 8));
        var string = url + '/user';
        var jqxhr = $_1_7.post(
                string,
                { action: 'getCurrentUserID' },
        cb,
                'json');
    },
    callOnLoad: function (cb) {
        if (ajaxSetupANDajaxPrefilterBindingCompleted)
            cb();
        else
            setTimeout(function () {
                axiomUtils.callOnLoad(cb);
            }, 200);
    }
};

var globalStartDateForTimer;
function resetTimer() {
    globalStartDateForTimer = new Date();
}
function getTimerSeconds() {
    return ((new Date()).getTime() - globalStartDateForTimer.getTime()) / 1000;
}
function clone(obj) {
    if (null == obj || "object" != typeof obj)
        return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) {
            if (null == obj[attr] || "object" != typeof obj[attr])
                copy[attr] = clone(obj[attr]);
            else
                copy[attr] = obj[attr];
        }
    }
    return copy;
}
function showBusyWindow(message, container, forced) {
    hideBusyWindow(container, forced);
    container = typeof container !== 'undefined' ? container : 'container';
    if (ajaxCount > 0 || forced) {
        var html = '<div id="loadpage" class="loader-overlay" style="height:auto;"><div  class="progress" style="height:auto;"><p>' + message + '</p></div></div>';
        $_1_7('#' + container).append(html);
    }
}

function hideBusyWindow(container, forced) {
    container = typeof container !== 'undefined' ? container : 'container';
    if (ajaxCount == 0 || forced) {
        $_1_7('#' + container + ' > #loadpage').remove();
    }
}

function updateBusyWindow(message, container) {
    container = typeof container !== 'undefined' ? container : 'container';
    if ($_1_7('#' + container).find('#loadpage p').length == 0) {
        var html = '<div id="loadpage" class="loader-overlay" style="height:auto;"><div class="progress" style="height:auto;"><p>' + message + '</p></div></div>';
        $_1_7('#' + container).append(html);
    }
    $_1_7('#' + container + ' > #loadpage p').html(message);
}

function common_contains(parent, descendant) {
    if (parent == undefined || parent == null)
        return false;
    // compareposition returns false in this case
    if (parent == descendant)
        return true;

    if (parent.contains) {
        return parent.contains(descendant);
    } else {
        return !!(descendant.compareDocumentPosition(parent) & 8);
    }
}

function replaceSpecialChar(value) {
    if (value == undefined)
        return '';
    var strTemp = value;
    strTemp = strTemp.toString().replace(/\\/g, '\\\\');
    strTemp = strTemp.toString().replace(/\'/g, "''");
    strTemp = strTemp.toString().replace(/\"/g, '\\"');
    strTemp = strTemp.toString().replace(/\\r/g, '\\\\r');
    strTemp = strTemp.toString().replace(/\\n/g, '\\\\n');
    strTemp = strTemp.toString().replace(/\r/g, '\\r');
    strTemp = strTemp.toString().replace(/\n/g, '\\n');
    return strTemp;
}

function common_replaceSpecialChar(value) {
    var strTemp = value;
    strTemp = strTemp.toString().replace(/\\/g, '\\\\');
    strTemp = strTemp.toString().replace(/\'/g, "''");
    strTemp = strTemp.toString().replace(/\"/g, '\\"');
    return strTemp;
}

function commons_parseFloat_Array(values) {
    var returnValues = [];
    for (var i = 0; i < values.length; i++) {
        returnValues.push(parseFloat(values[i]));
    }
    return returnValues;
}
// function getBaseUrlString() {
//     return "";
// }
function common_RedirectToNorights() {
    window.location.href = "/noRights";
}
function splitByChar(line, splitChar, enclosedStartChar, enclosedEndChar, removeEnclosedChar, trim, escapeChar = '"') {
    let response = [];
    let currentProcessingLine = "";
    let isFirstCharEnclosedChar = enclosedStartChar == line[0] ? true : false;
    let fieldIsEnclosed = isFirstCharEnclosedChar;
    const addCurrentLineToResponse = () => {
      if (trim) {
        currentProcessingLine.trim();
      }
      let localValues = [];
      if(removeEnclosedChar === false && fieldIsEnclosed){
        localValues.push(enclosedStartChar);    
      }
      localValues.push(currentProcessingLine);
      if(removeEnclosedChar === false && fieldIsEnclosed){
        localValues.push(enclosedEndChar);    
      }
      response.push(localValues.join(""));
      currentProcessingLine = "";
    };
    const checkIfSplitChar = (index) => {
      return splitChar.split('').every((c, i) => line[index+i] === c);
    }

    for (let i = isFirstCharEnclosedChar ? 1 : 0; i < line.length; i++) {
        let currentChar = line[i];
        if (
            isFirstCharEnclosedChar &&
            currentChar == escapeChar &&
            line[i + 1] == enclosedEndChar
        ) {
            currentProcessingLine += line[i+1];
            i++;
        } else if (isFirstCharEnclosedChar && currentChar == enclosedEndChar) {
            isFirstCharEnclosedChar = false;
        } else if (!isFirstCharEnclosedChar && checkIfSplitChar(i)) {
            addCurrentLineToResponse();
            i+=splitChar.length -1;
            isFirstCharEnclosedChar = enclosedStartChar ==  line[i+1] ? true : false;
            fieldIsEnclosed = isFirstCharEnclosedChar;
            if (isFirstCharEnclosedChar) i++
        } else {
            currentProcessingLine += currentChar;
        }
    }

    addCurrentLineToResponse();

    return response;
}
//Hitesh
var axiomConsole = {
    log: function (key, value, visible, filterKey) {
        if (typeof (console) != 'undefined') {
            if (visible) {
                if (value == undefined)
                    console.log(key);
                else
                    console.log([key, value]);
            }
        }
    }
}
function getRoundUpAmount(Value) {
    var val = 0;
    //    if (Value > 1000 * 100 * 100) {
    //        val = Value / (1000 * 1000);
    //        val = (Math.round(val * 100) / 100).toString() + 'Cr';
    //    }
    //    else if (Value > 1000 * 100) {
    //        val = Value / (1000 * 100);
    //        val = (Math.round(val * 100) / 100).toString() + 'L';
    //    }

    var actualValue = Value;
    if (Value < 0)
        Value = Value * -1;

    if (Value > 1000 * 1000) {
        val = Value / (1000 * 1000);
        if (actualValue < 0)
            val = parseFloat(val) * -1;
        val = (Math.round(val * 100) / 100).toString() + ' M';
    }
    else if (Value > 1000) {
        val = Value / (1000);
        if (actualValue < 0)
            val = (parseFloat(val) * -1).toString();
        val = (Math.round(val * 100) / 100).toString() + ' K';
    }
    else {
        if (actualValue < 0)
            Value = (parseFloat(Value) * -1).toString();
        val = (Math.round(Value * 100) / 100).toString();
    }

    return val;
}

function getRoundUpAmountInLacs(Value) {
    var val = 0;

    var actualValue = Value;
    val = Value / (100 * 1000);
    val = (Math.round(val * 100) / 100).toString() + ' Lacs';

    return val;
}

function getRoundUpAmountIndianFormat(Value) {

    var val = 0;
    var actualValue = Value;

    if (Value < 0) {
        Value = Value * -1;
    }

    if (Value < 1000) {
        val = actualValue;
    }
    else if (Value < 100000) {
        val = actualValue / 1000;
        val = parseFloat(val).toFixed(2).toString() + ' K';
    } else if (Value < 10000000) {
        val = actualValue / 100000;
        val = parseFloat(val).toFixed(2).toString() + ' Lacs';
    } else {
        val = actualValue / 10000000;
        val = parseFloat(val).toFixed(2).toString() + ' Cr.';
    }


    return val;
}
/**********************************************************
<Summary>
<Name>downloadFile</Name>
<Description> download files</Description>
<Params>fileName</Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
var dwindow = null;
function downloadFile(fileName, tableName) {
    var url = getBaseUrlString();
    jQuery_1_7.support.cors = true;
    dwindow = window.open(url + "/downloadFile/" + tableName + "/" + encodeURIComponent(fileName), "_blank");
    //    setTimeout(function () {
    //        dwindow.close();
    //    }, 1000);
    //window.location = url + "/downloadFile/" + tableName + "/" + encodeURIComponent(fileName);
}

/**********************************************************
<Summary>
<Name>getBaseUrlString</Name>
<Description> Get Base URL</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getActualURL() {
    var url = document.URL;
    url = url.substr(url.indexOf('/', 8) + 1, url.length);
    url = url.replace(/\%20/ig, ' ');
    jQuery_1_7.support.cors = true;
    return url;
}

/**********************************************************
<Summary>
<Name>getUrlStringUser</Name>
<Description> Get Base URL for User</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringUser() {
    return getBaseUrlString() + '/User';
}

/**********************************************************
<Summary>
<Name>getUrlStringTable</Name>
<Description> Get Base URL for Table</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringTable() {
    return getBaseUrlString() + '/Table';
}
/**********************************************************
<Summary>
<Name>getUrlStringFTP</Name>
<Description> Get Base URL for FTP</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringFTP() {
    return getBaseUrlString() + '/ftp';
}
/**********************************************************
<Summary>
<Name>getUrlStringSQL</Name>
<Description> Get Base URL for SQL</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringSQL() {
    return getBaseUrlString() + '/sql';
}

/**********************************************************
<Summary>
<Name>getUrlStringProject</Name>
<Description> Get Base URL for Project</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringProject() {
    return getBaseUrlString() + '/Project';
}

/**********************************************************
<Summary>
<Name>getUrlStringWidget</Name>
<Description> Get Base URL for Widget</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringWidget() {
    return getBaseUrlString() + '/Widget';
}
/**********************************************************
<Summary>
<Name>getUrlStringTask</Name>
<Description> Get Base URL for Task</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringTask() {
    return getBaseUrlString() + '/Task';
}
/**********************************************************
<Summary>
<Name>getUrlStringTask</Name>
<Description> Get Base URL for Task</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringConnector() {
    return getBaseUrlString() + '/Connector';
}
/**********************************************************
<Summary>
<Name>getUrlStringDashboard</Name>
<Description> Get Base URL for Dashboard</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringDashboard() {
    return getBaseUrlString() + '/Reports';
}

/**********************************************************
<Summary>
<Name>getUrlStringApprFlow</Name>
<Description> Get Base URL for Approval Flow</Description>
<Params></Params>
<ReturnType></ReturnType>
</Summary>
***********************************************************/
function getUrlStringApprFlow() {
    return getBaseUrlString() + '/ApprFlow';
}
function getProperID(str) {
    str = str.replace(/\\/gi, '\\\\');
    str = str.replace(/\`/gi, '\\`');
    str = str.replace(/\~/gi, '\\~');
    str = str.replace(/\!/gi, '\\!');
    str = str.replace(/\@/gi, '\\@');
    str = str.replace(/\#/gi, '\\#');
    str = str.replace(/\$_1_7/gi, '\\$_1_7');
    str = str.replace(/\%/gi, '\\%');
    str = str.replace(/\^/gi, '\\^');
    str = str.replace(/\&/gi, '\\&');
    str = str.replace(/\*/gi, '\\*');
    str = str.replace(/\(/gi, '\\(');
    str = str.replace(/\)/gi, '\\)');
    str = str.replace(/\_/gi, '\\_');
    str = str.replace(/\-/gi, '\\-');
    str = str.replace(/\+/gi, '\\+');
    str = str.replace(/\=/gi, '\\=');
    str = str.replace(/\|/gi, '\\|');
    str = str.replace(/\{/gi, '\\{');
    str = str.replace(/\}/gi, '\\}');
    str = str.replace(/\[/gi, '\\[');
    str = str.replace(/\]/gi, '\\]');
    str = str.replace(/\;/gi, '\\;');
    str = str.replace(/\:/gi, '\\:');
    str = str.replace(/\'/gi, '\\\'');
    str = str.replace(/\"/gi, '\\"');
    str = str.replace(/\./gi, '\\.');
    str = str.replace(/\,/gi, '\\,');
    str = str.replace(/\</gi, '\\<');
    str = str.replace(/\>/gi, '\\>');
    str = str.replace(/\?/gi, '\\?');
    str = str.replace(/\//gi, '\\/');
    str = str.replace(/ /gi, '-');
    return str;
}

module.exports={
    axiomUtils:axiomUtils,
    resetTimer:resetTimer,
    getTimerSeconds:getTimerSeconds,
    hideBusyWindow:hideBusyWindow,
    showBusyWindow:showBusyWindow,
    updateBusyWindow:updateBusyWindow,
    common_contains:common_contains,
    replaceSpecialChar:replaceSpecialChar,
    common_replaceSpecialChar:common_replaceSpecialChar,
    splitByChar:splitByChar,
    
}